//Script for controlling time slot variant visibility on the December Delivery Page

console.log('November time slot logic loaded');
var three2six = document.getElementById('template--15360722731223__main-Time Slot-2');
var three2sixLabel = document.getElementById('template--15360722731223__main-Time Slot-2').nextElementSibling;
three2six.style.display = 'none';
three2sixLabel.style.display = 'none';

var nov24 = document.getElementById('template--15360722731223__main-Date-0').addEventListener("click", Weekday);
var nov25 = document.getElementById('template--15360722731223__main-Date-1').addEventListener("click", Weekend);
var nov26 = document.getElementById('template--15360722731223__main-Date-2').addEventListener("click", Weekend);
var nov27 = document.getElementById('template--15360722731223__main-Date-3').addEventListener("click", Weekday);
var nov28 = document.getElementById('template--15360722731223__main-Date-4').addEventListener("click", Weekday);
var nov29 = document.getElementById('template--15360722731223__main-Date-5').addEventListener("click", Weekday);
var nov30 = document.getElementById('template--15360722731223__main-Date-6').addEventListener("click", Weekday);


function Weekday() {
  console.log('Weekday Triggered');
three2six.style.display = 'none';
three2sixLabel.style.display = 'none';
}

function Weekend() {
  console.log('Weekend Triggered');
three2six.style.display = 'inline-block';
three2sixLabel.style.display = 'inline-block';
}